export default "__VITE_ASSET__BhAuXe1x__"